import { Component } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { Portable404Component } from "./404portable.component";

@Component({
    imports: [Portable404Component],
    templateUrl: "./404.component.html"
})
export class PageNotFoundComponent {
    public constructor(private events: EventBroker) {

    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
    }

    public ngOnDestroy(): void {
        this.events.ui.showNavbarEvent.emit();
    }
}